<div class="row">
  <div class="col-xl-9">
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between border-bottom">
          <p>Custom Earnings Description</p>
          <div class="d-flex align-items-center">
            <!-- <label class="col-form-label">Business Entity:&nbsp; </label> -->
            <!-- TODO: Do not show select box if user is an employee -->
            <select class="form-select" (change)="onBusinessSelect($event)">
              <option selected value="">Select Business Entity</option>
              <option *ngFor="let item of businessesList" [value]="item.id">
                {{ item.businessName | capitalize }}
              </option>
            </select>
          </div>
        </div>
        <div class="content">
          <table class="table datatable">
            <thead class="thead-light">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Business Entity</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of customEarnings$ | async">
                <td>{{ item.name }}</td>
                <td style="word-wrap: break-word; white-space: normal">{{ item.description }}</td>
                <td>
                  <div *ngIf="businesses$ | async as businesses">
                    <ng-container *ngFor="let business of businesses">
                      <ng-container *ngIf="item.belongsTo === business.id">
                        {{ business.businessName }}
                      </ng-container>
                    </ng-container>
                  </div>
                </td>
                <td>
                  <div class="action-icon d-inline-flex">
                    <a
                      href="javascript:void(0);"
                      (click)="openEditModal(addEarningModal, item)"
                      *appHasPermission="{ customEarnings: ['edit'] }"
                      ><i class="ti ti-edit"></i
                    ></a>
                    <a
                      href="javascript:void(0);"
                      (click)="openDeleteModal(deleteModal, item)"
                      *appHasPermission="{ customEarnings: ['delete'] }"
                      ><i class="ti ti-trash"></i
                    ></a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="col-xl-3 theiaStickySidebar" *appHasPermission="{ customEarnings: ['add'] }">
    <div class="card">
      <div class="card-body">
        <!-- <div class="d-flex flex-column list-group settings-list"> -->
        <div class="d-grid">
          <button (click)="openModel(addEarningModal)" class="btn btn-primary" type="button">
            + New Earning
          </button>
        </div>
        <!-- </div> -->
      </div>
    </div>
  </div>
</div>

<!-- models -->

<!-- Add Earning Modal -->
<ng-template #addEarningModal let-modal>
  <div class="modal-header header-border justify-content-between m-2">
    <h5 class="modal-title">Add New Earning</h5>
    <button type="button" class="btn-close custom-btn-close" aria-label="Close" (click)="onClose()">
      <i class="ti ti-x"></i>
    </button>
  </div>

  <div class="modal-body m-2">
    <div class="contact-grids-tab">
      <ul class="nav nav-underline" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 1"
          (click)="stepChange(1)"
        >
          <span class="nav-link" [class.active]="currentStep === 1">Basic Information</span>
        </li>
        <li
          class="nav-item"
          role="presentation"
          [class.active]="currentStep === 2"
          (click)="stepChange(2)"
        >
          <span class="nav-link" [class.active]="currentStep === 2">Advanced</span>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <form [formGroup]="form">
        <!-- Step 1 (Basic Info) -->
        <div *ngIf="currentStep === 1">
          <!-- TODO: Do not show select box if user is an employee -->
          <div class="my-4">
            <label for="select-business" class="form-label"
              >Business Entity Name <span class="text-danger">*</span></label
            >
            <select id="select-business" class="form-select" formControlName="belongsTo">
              <!-- <option disabled>Select Business</option> -->
              <option *ngFor="let item of businessesList" [value]="item.id">
                {{ item.businessName | capitalize }}
              </option>
            </select>
            <div *ngIf="form.get('belongsTo')?.errors?.['required']">
              <span class="text-danger">
                {{ getErrorMessage('belongsTo') }}
              </span>
            </div>
          </div>
          <div id="first-field">
            <div class="row earning-row">
              <div>
                <label for="name" class="form-label"
                  >Earning Name <span class="text-danger">*</span></label
                >
                <input
                  appTrimInput
                  type="text"
                  id="name"
                  class="form-control"
                  formControlName="name"
                />
                <div *ngIf="form.get('name')?.errors?.['required']">
                  <span class="text-danger">
                    {{ getErrorMessage('name') }}
                  </span>
                </div>
              </div>
              <div>
                <label for="description" class="form-label">Description</label>
                <textarea
                  id="description"
                  class="form-control"
                  formControlName="description"
                  maxlength="255"
                ></textarea>
              </div>
            </div>
            <div class="my-4" formGroupName="info">
              <label for="payType" class="form-label">Pay Type</label>
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="fixedPay"
                  value="fixedPay"
                  formControlName="payType"
                />
                <label class="form-check-label" for="fixedPay">
                  Fixed Pay: (Fixed amount paid at the end of every month)
                </label>
              </div>
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="variablePay"
                  value="variablePay"
                  formControlName="payType"
                />
                <label class="form-check-label" for="variablePay">
                  Variable Pay: (Variable amount paid during any payroll)
                </label>
              </div>
            </div>
            <div class="my-4" formGroupName="info">
              <label for="calculationType">Calculation Type</label>
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="flatAmount"
                  value="flatAmount"
                  formControlName="calculationType"
                />
                <label class="form-check-label" for="flatAmount"> Flat Amount </label>
              </div>
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="percentageOfBasic"
                  value="percentageOfBasic"
                  formControlName="calculationType"
                />
                <label class="form-check-label" for="percentageOfBasic">
                  Percentage of Basic
                </label>
              </div>
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="percentageOfCTC"
                  value="percentageOfCTC"
                  formControlName="calculationType"
                />
                <label class="form-check-label" for="percentageOfCTC"> Percentage of CTC </label>
              </div>
            </div>
            <div class="col-lg-12 text-end form-wizard-button">
              <button
                type="button"
                (click)="goToNextStep()"
                [disabled]="!form.get('name')?.valid || !form.get('belongsTo')?.valid"
                class="btn btn-primary wizard-next-btn"
              >
                Save & Next
              </button>
            </div>
          </div>
        </div>
        <!-- Step 2 (Advanced) -->
        <div *ngIf="currentStep === 2" formGroupName="info">
          <div class="row">
            <div class="my-4">
              <label for="taxDeductionPreference" class="form-label"
                >Tax deduction preference</label
              >
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="subsequentPayrolls"
                  value="subsequentPayrolls"
                  formControlName="taxDeductionPreference"
                />
                <label class="form-check-label" for="subsequentPayrolls">
                  Deduct tax in subsequent payrolls of the financial year
                </label>
              </div>
              <div class="form-check">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="radio"
                  id="samePayroll"
                  value="samePayroll"
                  formControlName="taxDeductionPreference"
                />
                <label class="form-check-label" for="samePayroll">
                  Deduct tax in the same payroll
                </label>
              </div>
            </div>
            <div class="my-4">
              <div class="form-check form-switch">
                <label class="form-check-label" for="taxable">Taxable</label>
                <input
                  appTrimInput
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="taxable"
                  formControlName="taxable"
                />
              </div>
            </div>
            <div class="my-4">
              <div class="form-check form-switch">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="isInCTC"
                  formControlName="isInCTC"
                />
                <label class="form-check-label" for="isInCTC">Is in CTC</label>
              </div>
            </div>
            <div class="my-4">
              <div class="form-check form-switch">
                <input
                  appTrimInput
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="proRataBasis"
                  formControlName="proRataBasis"
                />
                <label class="form-check-label" for="proRataBasis"
                  >Calculation pro-rata basis</label
                >
              </div>
            </div>
            <div class="col-lg-12 text-end form-wizard-button">
              <button
                type="submit"
                (click)="sendDataToParent()"
                class="btn btn-primary wizard-next-btn"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<!-- /Add Earning Modal -->

<!-- Delete Modal -->
<ng-template #deleteModal let-modal>
  <div class="modal-body text-center">
    <span class="avatar avatar-xl bg-transparent-danger text-danger mb-3">
      <i class="ti ti-trash-x fs-36"></i>
    </span>
    <h4 class="mb-1">Confirm Delete</h4>
    <p class="mb-3">You want to delete the entry, this can't be undone once you delete.</p>
    <div class="d-flex justify-content-center">
      <a
        href="javascript:void(0);"
        class="btn btn-light me-3"
        data-bs-dismiss="modal"
        (click)="onClose()"
        >Cancel</a
      >
      <a href="javascript:void(0);" class="btn btn-danger" (click)="sendDataToParent()"
        >Yes, Delete</a
      >
    </div>
  </div>
</ng-template>
<!-- /Delete Modal -->
